/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LabelData } from './LabelData';
import type { OrderPageDataTypes } from './OrderPageDataTypes';
import type { PartialLabelData } from './PartialLabelData';
import type { ToggleButtonGroupUIObjectInnerData } from './ToggleButtonGroupUIObjectInnerData';
import type { UIObjectConditionData } from './UIObjectConditionData';

export type ToggleButtonGroupUIObjectData = {
  id: string;
  type: ToggleButtonGroupUIObjectData.type;
  condition?: UIObjectConditionData;
  data_type: OrderPageDataTypes;
  name?: string;
  label: LabelData;
  external_label?: PartialLabelData;
  options: Array<ToggleButtonGroupUIObjectInnerData>;
};

export namespace ToggleButtonGroupUIObjectData {
  export enum type {
    TOGGLE_BUTTON_GROUP = 'toggleButtonGroup',
    TOGGLE_BUTTON_GROUP_DYNAMIC_PRICE = 'toggleButtonGroupDynamicPrice',
  }
}
